import { Region } from "@/shared/types/type/search"

const handleRegionIds = <T extends string | number>(list: T[]) => {
  const count = Object.create(null)
  for (const item of list) {
    count[item] = (count[item] || 0) + 1
  }
  const result: T[] = []
  for (const value of list) {
    if (count[value] === 1) {
      result.push(value)
    }
  }
  return result
}

export const resolveSearchRegionIds = (regionList: Region[], regionIds: number[]) => {
  const regionListIds = regionList.map((region) => region.id)
  const checkedRegionIds = regionIds.filter((id) => regionListIds.includes(id))
  if (checkedRegionIds.length > 0) {
    const addRegionIds = checkedRegionIds
      .map((id) => regionList.find((region) => region.id === id)?.children.map((child) => child.id))
      .flat() as number[]
    const newRegionIds = [...regionIds, ...addRegionIds]
    return handleRegionIds(newRegionIds) as number[]
  }
  return regionIds
}
